import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { MEDIA_ACTIONS } from "../../../../redux/media/actions";
import {
  mediaCreating,
  mediaFilters,
  mediaLoaded,
  mediaMeta,
  selectMedia
} from "../../../../redux/media/selectors";
import Confirm from "../../../../base/Confirm";
import { dateRender } from "../../../../libs/utils";
import ListView from "../../../../base/ListView";
import Dropzone from "react-dropzone";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { NOTIFICATION_ACTIONS } from "../../../../redux/notifications/actions";
import { Trans } from "react-i18next";

class _Medias extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      media: this.props.media,
      activeMedia: null,
      mediaLoaded: this.props.mediaLoaded
    };

    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
    this._onDrop = this._onDrop.bind(this);
  }

  static propTypes = {
    media: PropTypes.array,
    mediaLoaded: PropTypes.bool,
    loadAllMedia: PropTypes.func,
    match: PropTypes.object,
    createMedia: PropTypes.func,
    updateMedia: PropTypes.func,
    deleteMedia: PropTypes.func,
    mediaCreating: PropTypes.bool,
    mediaMeta: PropTypes.object,
    filters: PropTypes.object,
    updateFilters: PropTypes.func,
    event: PropTypes.object,
    pushNotifaction: PropTypes.func,
    "event.id": PropTypes.number,
    "match.params": PropTypes.object,
    "match.params.id": PropTypes.string,
    "media.filter": PropTypes.func
  };

  UNSAFE_componentWillMount() {
    this.props.loadAllMedia(this.props.event.id);
  }

  _handleFilterUpdate(filters) {
    this.props.updateFilters(filters);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const newState = {
      media: nextProps.media,
      mediaLoaded: nextProps.mediaLoaded
    };

    this.setState(newState);
  }

  _handleDelete(id) {
    Confirm(
      "Are you sure you want to delete this media? This action can not be undone, please make sure no festival is using this media.",
      {
        title: "Delete Media",
        confirmStyle: "btn-danger",
        confirmText: "Delete"
      }
    ).then(
      result => {
        this.props.deleteMedia(this.props.event.id, id);
      },
      result => {}
    );
  }

  _onDrop(acceptedFiles, rejectedFiles) {
    acceptedFiles.forEach(file => {
      let data = new FormData();
      data.append("file", file);
      this.props.createMedia(this.props.event.id, data);
    });
  }

  render() {
    const { media } = this.state;
    const { mediaMeta, filters, event } = this.props;

    const listViewConf = {
      dataSet: media,
      dataMeta: mediaMeta,
      columns: [
        {
          key: "fileName",
          value: "Name",
          sort: "fileName"
        },
        {
          key: "updatedAt",
          value: "Last Updated",
          sort: "updated_at",
          render: media => dateRender(media.updatedAt)
        }
      ],
      baseFilters: filters,
      filters: [
        {
          label: "Name",
          icon: "la-search",
          type: "text",
          key: "file_name"
        }
      ],
      actions: {
        deleteLink: true,
        editLink: false,
        detailsLink: false,
        customLink: media => (
          <span>
            <CopyToClipboard
              text={media.url}
              onCopy={() =>
                this.props.pushNotifaction(
                  "success",
                  "Link copied to your clipboard"
                )
              }
            >
              <button className="btn btn-outline-success m-btn btn-sm  m-btn--icon m--margin-left-5">
                <span>
                  <i className="la la-copy" />
                  <span>Copy Link</span>
                </span>
              </button>
            </CopyToClipboard>
          </span>
        ),
        deleteFunction: this._handleDelete
      },
      url: "/admin/event/" + event.id + "/media"
    };

    return (
      <div className="row">
        <div className="col-xl-8">
          <ListView
            config={listViewConf}
            handleDelete={this._handleDelete}
            handleFilterUpdate={this._handleFilterUpdate}
          />
        </div>
        <div className="col-xl-4">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon">
                    <i className="flaticon-map-location" />
                  </span>
                  <h3 className="m-portlet__head-text">Upload Media</h3>
                </div>
              </div>
            </div>
            <div className="m-portlet__body">
              <Dropzone
                onDrop={this._onDrop}
              >
                {({ getRootProps }) => (
                    <div
                        {...getRootProps()}
                        className="m-dropzone dropzone dz-clickable"
                    >
                      <div className="m-dropzone__msg dz-message needsclick">
                        <h3 className="m-dropzone__msg-title">
                          <Trans>admin.event.media.upload.title</Trans>
                        </h3>
                        <span className="m-dropzone__msg-desc">
                          <Trans>admin.event.media.upload.description</Trans>
                        </span>
                      </div>
                    </div>
                )}
              </Dropzone>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  loadAllMedia: eventId => dispatch(MEDIA_ACTIONS.loadAllRequest(eventId)),
  createMedia: (eventId, file) =>
      dispatch(MEDIA_ACTIONS.createRequest(eventId, file)),
  deleteMedia: (eventId, id) =>
      dispatch(MEDIA_ACTIONS.deleteRequest(eventId, id)),
  updateFilters: filters => dispatch(MEDIA_ACTIONS.updateFilters(filters)),
  pushNotifaction: (type, text) =>
    dispatch(NOTIFICATION_ACTIONS.push(type, text))
});

const mapStateToProps = function(state) {
  return {
    media: selectMedia(state),
    mediaLoaded: mediaLoaded(state),
    mediaCreating: mediaCreating(state),
    mediaMeta: mediaMeta(state),
    filters: mediaFilters(state)
  };
};

const Medias = connect(mapStateToProps, mapDispatchToProps)(_Medias);

export default Medias;
